import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ role, verified, size = 15, showLabel = false }) {
  if (!verified) return null;
  if (role !== "scout" && role !== "coach") return null;
  return (
    <span
      data-testid="verified-badge"
      title={`Verified ${role}`}
      className="inline-flex items-center gap-1 align-middle"
    >
      <BadgeCheck
        style={{ width: size, height: size }}
        className="text-black fill-white shrink-0"
      />
      {showLabel && (
        <span className="text-[10px] uppercase tracking-widest text-white bg-[#262626] border border-[#404040] px-1.5 py-0.5 rounded-sm">
          {role}
        </span>
      )}
    </span>
  );
}
